<template>
  <EditorNodeWrapper
    :class="['node-container', 'embed-slideshow-container', blockWidthClass]"
    :style="{ paddingTop: aspectRatioPadding + '%' }"
    @observe-node-visibility="$emit('observe-node-visibility', { ...$event, nodeId: node.id })"
  >
    >
    <iframe
      ref="iframeRef"
      :src="node.url"
      frameborder="0"
      :width="dimensions.width"
      :height="dimensions.height"
      allowfullscreen="true"
      mozallowfullscreen="true"
      webkitallowfullscreen="true"
    ></iframe>
  </EditorNodeWrapper>
</template>
<script lang="ts" setup>
import { onMounted, ref, computed } from 'vue';
import type { EBlockWidth, EmbedSlideShow } from '@getaccept/editor-lib';
import EditorNodeWrapper from './EditorNodeWrapper.vue';

const { blockWidthClass, node } = defineProps<{
  blockWidthClass?: EBlockWidth;
  node: EmbedSlideShow;
}>();

defineEmits<{
  'observe-node-visibility': [
    {
      nodeId: string;
      visible: boolean;
    },
  ];
}>();

const iframeRef = ref(null);
const aspectRatioPadding = ref(60);

const getPadding = () => {
  const iframe = iframeRef.value;
  const width = iframe.getAttribute('width');
  const height = iframe.getAttribute('height');
  return (parseFloat(height) / parseFloat(width)) * 100 + 1.5;
};

const dimensions = computed(() => node.dimensions || { width: null, height: null });

onMounted(() => {
  aspectRatioPadding.value = getPadding();
});
</script>
<style lang="scss" scoped>
@import '@getaccept/editor-lib/src/scss/editor-node-embed-slideshow';
</style>
